'use client';

import { useState } from 'react';
import { AppDownloadModal } from '../../../../../components/AppDownloadModal/AppDownloadModal';
import { FAQ } from '../../../../../components/FAQ/FAQ';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import {
  RegionDetailFields,
  RegionTopWaterNodeFields,
  SpeciesByGroupNodeFields,
} from '../../../../../generated/graphql';
import { getFAQData } from './helpers/getFAQData';

interface IProps {
  className?: string;
  id?: string;
  region: RegionDetailFields;
  speciesGroupName: string;
  species: SpeciesByGroupNodeFields[];
  topFishingWaters: RegionTopWaterNodeFields[];
}

export const SpeciesGroupRegionFAQSection = ({
  className,
  id,
  region,
  speciesGroupName,
  species,
  topFishingWaters,
}: IProps) => {
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);
  const { currentPage } = useAnalytics();

  const handleCTAClick = (): void => {
    trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: 'FAQSection',
        source_id: region.id ?? undefined,
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };

  const faqData = getFAQData({
    handleCTAClick,
    region,
    speciesGroupName,
    species,
    topFishingWaters,
  });

  if (faqData.length === 0) {
    return null;
  }

  return (
    <FAQ className={className} faqData={faqData} headingVariant="sm" id={id} showFAQMetaData>
      <AppDownloadModal
        appDownloadSourceId={region.id ?? undefined}
        appDownloadSource="FAQSection"
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </FAQ>
  );
};
